export default __webpack_public_path__ + "static/media/k8s-components.e802bf65.svg";